import { Box } from "@mui/material";
import React from "react";
import HelloBar from "./helloBar/HelloBar";
import { maintenanceScheduledMsg, viewDetails } from "./messages";
import { CustomLink } from "./link/Link";
import { useDispatch, useSelector } from "react-redux";
import { setMaintenanceModalOpen } from "../redux/actions";
import CancelIcon from "@mui/icons-material/Cancel";
import WalletSymbols from "./WalletSymbols";
import { calenderClockIcon } from "./images";
import { SET_IS_HIDE_UNDER_MAINTENANCE_BAR } from "../redux/types";
import moment from "moment-timezone";

function MaintenanceBar({ color, fontColor, sx, isFromBrowser }) {
  const { isHideUnderMaintenanceBar, maintenance } = useSelector(
    (state) => state.common
  );

  const dispatch = useDispatch();

  return (
    <HelloBar
      hide={isHideUnderMaintenanceBar}
      color={color}
      sx={sx}
      fontColor={fontColor}
      descriptionText={
        <Box lineHeight="1.5">
          {maintenanceScheduledMsg(
            moment(maintenance?.maintenance_data?.start_time).format(
              "DD/MM/YYYY"
            )
          )}{" "}
          <CustomLink
            size="small"
            sx={{
              color: isFromBrowser ? "inherit" : "#2A67FF",
              textDecoration: isFromBrowser ? "underline" : "none",
            }}
            onClick={() => dispatch(setMaintenanceModalOpen(true))}
          >
            {viewDetails}.
          </CustomLink>
        </Box>
      }
      besideComponent={
        isFromBrowser ? (
          <CancelIcon
            className="pointer-cursor"
            onClick={() =>
              dispatch({
                type: SET_IS_HIDE_UNDER_MAINTENANCE_BAR,
                payload: true,
              })
            }
          />
        ) : (
          <WalletSymbols
            customClass="cursor-pointer"
            symbol="close"
            action={() =>
              dispatch({
                type: SET_IS_HIDE_UNDER_MAINTENANCE_BAR,
                payload: true,
              })
            }
          />
        )
      }
      startIcon={
        isFromBrowser ? (
          <WalletSymbols symbol="calendar_clock" />
        ) : (
          <img
            src={calenderClockIcon}
            alt="icon"
            style={{ height: "34px", width: "34px" }}
          />
        )
      }
    />
  );
}

export default MaintenanceBar;
